import { render } from "./Registration.vue?vue&type=template&id=98cf3f86"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
script.render = render

export default script